export interface ApiQueryParamConfig {
  urlSegment: string;
  queryParam: string;
  queryValue: string;
}

export const QUERY_PARAM_CONFIGS: ReadonlyArray<ApiQueryParamConfig> = Object.freeze([
  { urlSegment: 'acs/chat-handler/', queryParam: 'api-version', queryValue: '2025-08-20' },
]);
